import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO = "https://customer-assets.emergentagent.com/job_culinary-connect-37/artifacts/dowryrls_582627c1-c0bf-47f6-ab36-5cc8b78702e3.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/api/auth/forgot-password`, {
        email, host_url: window.location.origin
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 pt-20 pb-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/"><img src={LOGO} alt="Logo" className="h-16 w-16 rounded-full mx-auto mb-4" /></Link>
          <h1 className="font-serif text-3xl text-white font-light">Forgot Password</h1>
          <p className="text-[#A0A0A0] text-sm mt-2">Enter your email to receive a reset link</p>
        </div>

        {sent ? (
          <div className="text-center border border-emerald-800/40 bg-emerald-950/20 p-8" data-testid="forgot-sent-msg">
            <div className="text-emerald-400 text-3xl mb-4">✓</div>
            <h2 className="font-serif text-xl text-white mb-3">Check Your Email</h2>
            <p className="text-[#A0A0A0] text-sm mb-6">
              If an account exists for <strong className="text-white">{email}</strong>, you&apos;ll receive a password reset link shortly.
            </p>
            <Link to="/login" className="text-[#D4AF37] text-sm hover:text-white transition-colors">
              Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] block mb-2">Email Address</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                required placeholder="your@email.com"
                data-testid="forgot-email-input"
                className="w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] py-2 text-white placeholder-white/25 text-sm outline-none transition-colors"
              />
            </div>
            {error && (
              <p className="text-red-400 text-sm bg-red-900/20 border border-red-900/30 px-4 py-3">{error}</p>
            )}
            <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
              className="w-full bg-[#D4AF37] text-black hover:bg-[#F3E5AB] py-4 font-medium tracking-widest uppercase text-sm transition-colors disabled:opacity-50">
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <div className="text-center">
              <Link to="/login" className="text-[#A0A0A0] text-sm hover:text-[#D4AF37] transition-colors">
                Back to Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
